/**
 * @generated SignedSource<<0933674f50dfcfba192b3452a2cb1f32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateSprintGoalInput = {
  id?: string | null;
  description?: string | null;
  stage?: string | null;
  done?: boolean | null;
  statusColor?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateSprintGoalMutation$variables = {
  input: UpdateSprintGoalInput;
};
export type UpdateSprintGoalMutation$data = {
  readonly updateSprintGoal: {
    readonly sprintGoal: {
      readonly id: string;
      readonly description: string | null;
      readonly stage: string | null;
      readonly statusColor: string | null;
    } | null;
  } | null;
};
export type UpdateSprintGoalMutation = {
  variables: UpdateSprintGoalMutation$variables;
  response: UpdateSprintGoalMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSprintGoalPayload",
    "kind": "LinkedField",
    "name": "updateSprintGoal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SprintGoal",
        "kind": "LinkedField",
        "name": "sprintGoal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statusColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateSprintGoalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateSprintGoalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "317397cb09298e7193d6adcf92898133",
    "id": null,
    "metadata": {},
    "name": "UpdateSprintGoalMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateSprintGoalMutation(\n  $input: UpdateSprintGoalInput!\n) {\n  updateSprintGoal(input: $input) {\n    sprintGoal {\n      id\n      description\n      stage\n      statusColor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "70a8db7ea3f16828032e84f838911262";

export default node;
